import type { RouteRecordRaw } from 'vue-router'

import { ensureRootRoutePath, type RedirectRoutePath } from '@/utilities/routers'

const routeAuthName = '/login'
const routeAuthPath = ensureRootRoutePath(routeAuthName)

const routeAuth: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/views/LoginView.vue')
  },
  meta: {
    requireAuth: false,
  },
  name: routeAuthName,
  path: routeAuthPath,
}

const redirectAuth: RedirectRoutePath = {
  // use no "name" attribute here, not working with global navigationGuard
  path: routeAuth.path,
}

export { redirectAuth, routeAuth }
